//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import RequestsWorks from './RequestsWorks.vue'

export default {
  components: {
    RequestsWorks
  },
  props: {
    requests: {
      type: Array,
      default: () => []
    },
    defaultOpened: {
      type: Boolean,
      default: false
    }
  }
}

